import { styled, css } from '@compiled/react';

import { token } from '@atlaskit/tokens';
import { N50, N80, N500, N800, N20, N700, N30, N40 } from '@atlaskit/theme/colors';

const buttonStyle = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '32px',
	width: '32px',
	border: 'none',
	borderRadius: '3px',
	background: token('color.background.neutral.subtle', 'transparent'),
	cursor: 'pointer',
	'&:hover': {
		background: token('color.background.neutral.subtle.hovered', 'rgba(9, 30, 66, 0.08)'),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const TableContainer = styled.div({
	height: '100%',
	position: 'relative',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LoadingOverlay = styled.div({
	pointerEvents: 'none',
	position: 'absolute',
	top: '0',
	right: '0',
	bottom: '0',
	left: '0',
	display: 'flex',
	WebkitBoxAlign: 'center',
	alignItems: 'center',
	WebkitBoxPack: 'center',
	justifyContent: 'center',
	backgroundColor: token('elevation.surface.overlay', 'white'),
	opacity: token('opacity.loading', '0.5'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const OverlaySpinnerContainer = styled.div({
	position: 'fixed',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const PaginationSpinnerContainer = styled.div({
	width: '100%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginTop: '30px',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginBottom: '30px',
	textAlign: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpaceItem = styled.div({
	width: '100%',
	height: '52px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	padding: `0 ${token('space.150', '12px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SpaceLink = styled.a<{ 'data-styled-selector'?: string }>({
	width: '100%',
	height: '52px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	'&:hover': {
		textDecoration: 'none',
		cursor: 'pointer',
	},
});
const spaceDirectorySpaceLinkSelector = 'spaceDirectory.SpaceLink';
SpaceLink.defaultProps = {
	'data-styled-selector': spaceDirectorySpaceLinkSelector,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconContainer = styled.div({
	position: 'absolute',
	right: token('space.150', '12px'),
	top: '10px',
	height: '32px',
	maxWidth: '120px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const IconPlaceholder = styled.div({
	height: '52px',
	width: '120px',
	flexShrink: 0,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Row = styled.div<{ 'data-styled-selector'?: string }>({
	width: '100%',
	borderRadius: '3px',
	height: '52px',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	position: 'relative',
	' --action-button-color': token('color.icon.accent.gray', N50),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	[`&:hover, [data-styled-selector="${spaceDirectorySpaceLinkSelector}"]:focus &`]: {
		color: token('color.text', N800),
		backgroundColor: token('color.background.neutral.hovered', N20),
		textDecoration: 'none',
		'--action-button-color': token('color.icon.subtle', N80),
	},
});
const spaceDirectoryTableRowSelector = 'spaceDirectory.Table.Row';
Row.defaultProps = {
	'data-styled-selector': spaceDirectoryTableRowSelector,
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Title = styled.div({
	minWidth: '260px',
	width: '30%',
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-space
	marginLeft: '10px',
	color: token('color.text', N800),
	lineHeight: '14px',
	padding: token('space.075', '6px'),
	borderRadius: '3px',
	whiteSpace: 'nowrap',
	overflow: 'hidden',
	textOverflow: 'ellipsis',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const MenuButton = styled.button<{ isOpen: boolean }>(buttonStyle, {
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	background: (props) =>
		props.isOpen ? token('color.background.neutral.subtle', 'rgba(9, 30, 66, 0.08)') : 'inherit',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&& svg': {
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
		color: (props) =>
			props.isOpen
				? token('color.icon', N500)
				: token('color.icon.subtle', 'var(--action-button-color)'),
	},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:hover svg': {
		color: token('color.icon', N500),
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CategoriesContainer = styled.div({
	width: '70%',
	marginLeft: token('space.200', '16px'),
	overflow: 'hidden',
	position: 'relative',
	whiteSpace: 'nowrap',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const Category = styled.button({
	padding: `${token('space.025', '2px')} ${token('space.075', '6px')}`,
	maxWidth: '180px',
	border: 'none',
	borderRadius: '3px',
	margin: token('space.050', '4px'),
	font: token('font.body'),
	background: token('color.background.neutral.subtle', N20),
	color: token('color.text', N700),
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap',
	cursor: 'pointer',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	[`[data-styled-selector="${spaceDirectoryTableRowSelector}"]:hover &, [data-styled-selector="${spaceDirectorySpaceLinkSelector}"]:focus &`]:
		{
			background: token('color.background.neutral', N30),
		},
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&:hover': {
		background: token('color.background.neutral', N40),
	},
});
